"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["value"];
var Count = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var value = _ref.value,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!(0, _isNumber2["default"])(value)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledCount, props, value);
});
Count.displayName = 'Count';
Count.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].number.isRequired
};
Count.defaultProps = {
  className: ''
};
var StyledCount = _styledComponents["default"].div.withConfig({
  displayName: "Count__StyledCount",
  componentId: "sc-1l9pjzb-0"
})(["background-color:#f8e71c;border-radius:50%;color:#17181a;font-size:12px;height:23px;line-height:23px;text-align:center;min-width:23px;border-radius:23px;padding:0 7px;"]);
var _default = exports["default"] = Count;